<template>
  <div>
    <v-autocomplete
      :prepend-icon="icon"
      multiple
      v-model="selectedLocal"
      :items="items"
      :rules="rules"
      :loading="isLoading"
      :search-input.sync="search"
      chips
      clearable
      hide-selected
      item-text="email_name"
      return-object
      :label="text"
      :filled="false"
      persistent-hint
      dense
      outlined
    >
      <!-- item-value="id" -->
      <!-- <template v-slot:prepend>
        <v-tooltip bottom >
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color='red'>mdi-alert-circle</v-icon>
          </template>
          Item obrigatório
        </v-tooltip>
      </template> -->
      
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>{{listTitle}}</v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:selection="{ attr, on, item, selected }">
        <v-chip
          v-bind="attr"
          :input-value="selected"
          color="blue-grey"
          class="white--text py-1 mt-2"
          v-on="on"
          small
          @click:close="removeItem(selected)"
          :close="multi"
        >
          <v-icon left>mdi-account-circle</v-icon>
          <span class="font-weight-bold">{{item.name}}</span>
          <span class="ml-1">| {{item.email}}</span>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar :size="item.avatar_url? 32 : 20" :color="!item.avatar_url? 'indigo' : ''" class="white--text">
          <v-icon v-if="!item.avatar_url"  small dark>mdi-account</v-icon>
          <!-- <span v-if="!item.avatar_url" class="white--text text-h5"></span> -->
          <v-img v-if="item.avatar_url" :src="item.avatar_url" class="my-3" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">{{item.name}}</v-list-item-title>
          <v-list-item-subtitle v-if="item.email">{{item.email}}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Api from '@/api'

export default {
  model: {
    prop: "selected",
    event: "selectedChange"
  },
  props: {
    ignore_ids:{
      type: Array,
      default:() => []
    },
    listTitle: {
      type: String,
      default: "Escolha uma opção"
    },
    text: {
      type: String,
      default: "Escolha uma opção"
    },
    icon: {
      type: String,
      default: "mdi-menu-down"
    },
    rules: {
      // Envie como :rules="[ruleRequired('Campo obrigatório!')]" importado de mixins/validations no componente pai.
      type: Array,
      default: () => []
    },

    multi: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    items: [],
    search: null
  }),
  methods: {
    removeItem(e){
      let index = this.selectedLocal.findIndex(el=> el.id === e.id)
      this.selectedLocal.splice(index, 1)
    },
    async getUsersFromApi(query = null){
      let obj = {
        company_id: this.activeCompanyId, 
        non_associated_members: !this.multi,
        query
      }
      return Api.User.searchUser(obj).then(r=> r.data).then(d=> {
        if(d){
          d = [d].flat()
          if(this.multi){
            let data_filtered = [...d.filter(el =>{
              if( this.ignore_ids.indexOf(el.id) >= 0){
                return false
              }else{
                return true
              }
            })]
            this.items.push(...data_filtered.map(o => {
              let {email, name, ...user} = o
              return {
                email_name: [email, name].join(' '),
                name, email, ...user
              }
            }))
          }else{
            this.items = [...d.map(o => {
              let {email, name, ...user} = o
              return {
                email_name: [email, name].join(' '),
                name, email, ...user
              }
            })];
          }
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => (this.isLoading = false));
    },
    ...mapActions({
      updateDoneItemOnlyIdb: 'Execution/updateDoneItemOnlyIdb',
    })
  },
  computed: {
    selectedLocal: {
      get() {
        return this.$attrs.selected;
      },
      set(value) {
        if(!this.multi){
          if (this.multi === false && value.length > 1) {
            value.shift();
          }
        }
        this.$emit("selectedChange", value);
      }
    },
    ...mapState({
      profile: state => state.User.oneUser,
      activeCompanyId: state => state.App.activeCompanyId
    }),
  },
  mounted () {
    if (this.$attrs.selected && this.$attrs.selected.length>0){
      this.setupSelected()
    }
  },
  watch: {
    search(val) {
      if (val && val.length >= 3 && !this.isLoading){
        this.isLoading = true;
  
        // Lazily load input items

        this.getUsersFromApi(val)
      }
    }
  }
};
</script>